export const ORDERS_CUSTOMER_ROOT_PATH = "/customer/orders";

export const ORDERS_CUSTOMER_RECEIPTS_GET_ALL_METHOD = "GET";
export const ORDERS_CUSTOMER_RECEIPTS_GET_ALL_SUFFIX = "/receipts/all";
/** GET /customer/orders/receipts/all */
export const ORDERS_CUSTOMER_RECEIPTS_GET_ALL_PATH = `${ORDERS_CUSTOMER_ROOT_PATH}${ORDERS_CUSTOMER_RECEIPTS_GET_ALL_SUFFIX}`;

export const ORDERS_CUSTOMER_RECEIPTS_GET_ONE_METHOD = "GET";
export const ORDERS_CUSTOMER_RECEIPTS_GET_ONE_PATH_PARAM = "orderId";
export const ORDERS_CUSTOMER_RECEIPTS_GET_ONE_SUFFIX = `/receipts/:${ORDERS_CUSTOMER_RECEIPTS_GET_ONE_PATH_PARAM}`;
/** GET /customer/orders/receipts/:orderId */
export const ORDERS_CUSTOMER_RECEIPTS_GET_ONE_PATH = `${ORDERS_CUSTOMER_ROOT_PATH}${ORDERS_CUSTOMER_RECEIPTS_GET_ONE_SUFFIX}`;

export const GET_LAST_ORDER_LINE_ITEMS_METHOD = "GET";
export const GET_LAST_ORDER_LINE_ITEMS_PATH_PARAM = "subscriptionId";
export const GET_LAST_ORDER_LINE_ITEMS_SUFFIX = `/items/last/:${GET_LAST_ORDER_LINE_ITEMS_PATH_PARAM}`;
/** GET /customer/orders/items/last */
export const GET_LAST_ORDER_LINE_ITEMS_PATH = `${ORDERS_CUSTOMER_ROOT_PATH}${GET_LAST_ORDER_LINE_ITEMS_SUFFIX}`;
